import jwtDecode from 'jwt-decode';

export const saviAuthTokenStorageKey = (auth0UserId: string) => `savi-auth-token-${btoa(auth0UserId)}`;

interface CachedSaviAuthToken {
  token: string;
  expiryEpochMs: number;
}

// stores the expiry alongside the token so freshness checks don't need to re-decode the JWT
export const cacheSaviAuthToken = (auth0UserId: string, token: string): void => {
  const expiryEpochMs = +jwtDecode<{ exp: string }>(token).exp * 1000;
  localStorage.setItem(saviAuthTokenStorageKey(auth0UserId), JSON.stringify({ token, expiryEpochMs }));
};

export const readCachedSaviAuthToken = (auth0UserId: string): CachedSaviAuthToken | null => {
  const raw = localStorage.getItem(saviAuthTokenStorageKey(auth0UserId));
  if (!raw) return null;

  try {
    return JSON.parse(raw) as CachedSaviAuthToken;
  } catch {
    return null;
  }
};

export const clearSaviAuthToken = (auth0UserId: string): void => {
  localStorage.removeItem(saviAuthTokenStorageKey(auth0UserId));
};
